import React, { useEffect, useRef, useState } from "react";
import { BsCheckCircle, BsCheckCircleFill, BsInfoCircle } from "react-icons/bs";
import {
  Form,
  Row,
  Col,
  Button,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  cifVerifyLicenseDetails,
  cityList,
  isPhoneNoInUse,
  isPhoneNoVerified,
  stateListData,
  validateAddress,
} from "@/api/bid";
import { buyerAgent } from "@/components/user/MyBids/Editcif/editcif/EditFormfields";
import { useSelector } from "react-redux";
import { ShimmerText } from "react-shimmer-effects";
import VerificationTick from "../../../../../../public/assets/images/verificationTick.svg"
import VerificationPending from "../../../../../../public/assets/images/verificationPending.svg";
import VerifyPhoneModal from "@/components/bid/VerifyPhoneModal";

import "@/components/bid/Bid.css";
const EditBuyersAgent = ({
  setCollapseAccordian,
  collapseAccordian,
  setSubmittedAccordions,
  submittedAccordions,
  isEnabled,
  agentData,
  setAgentData,
  selectedDescription,
  buyingForSelf,
  cifData,
  primaryBuyerData,
  cobuyerData


}) => {
  const [states, setStates] = useState([]);
  const [citySuggestions, setCitySuggestions] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [isAgentPhoneVerified, setIsAgentPhoneVerified] = useState(false);
  const [agentSendVerificationCode, setAgentSendVerificationCode] = useState({
    message: null,
    showCta: false,
  });
  const [showVerifyModal, setShowVerifyModal] = useState(false);

  const [getLicenceErrorDesc, setGetLicenceErrorDesc] = useState("");
  const individualLicenceState = useSelector(
    (state) => state?.propertyDetail?.getPropertyDetail?.propertyDetails
  );

  const agentFormRef = useRef({});

  // Fetch states on component mount
  useEffect(() => {
    fetchStateValues();
  }, []);
  useEffect(() => {
    if (agentData.stateId) {
      fetchCities(agentData.stateId);
    }
  }, [agentData.stateId]);

  const fetchStateValues = async () => {
    try {
      const data = await stateListData();
      setStates(data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchCities = async (stateId) => {
    try {
      const response = await cityList(stateId);
      if (response?.data?.data) {
        setAllCities(response.data.data);
      } else {
        setAllCities([]);
        console.warn("No city data received");
      }
      setCitySuggestions([]);
      setShowSuggestions(false);
    } catch (error) {
      console.error("Error fetching cities:", error);
      setAllCities([]);
      // Optionally show user-friendly error message
      setErrors((prev) => ({
        ...prev,
        cityError: "Unable to fetch cities. Please try again later.",
      }));
    }
  };

  // Update your handleAgentChange function
  // const handleAgentChange = (e) => {
  //   const { name, value } = e.target;
  //   setAgentData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));

  //   // Clear error for the field being changed
  //   setErrors((prev) => ({
  //     ...prev,
  //     [name]: undefined,
  //   }));

  //   if (name === "city") {
  //     const filteredCities = allCities.filter((city) =>
  //       city.toLowerCase().includes(value.toLowerCase())
  //     );
  //     setCitySuggestions(filteredCities);
  //     setShowSuggestions(true);
  //   }
  // };

  const handleSuggestionClick = (suggestion) => {
    setAgentData((prev) => ({
      ...prev,
      city: suggestion,
    }));
    setCitySuggestions([]);
    setShowSuggestions(false);
  };
  // First, create a validation function for agent data
  // const validateAgentData = (data) => {
  //   const errors = {};

  //   // Required field validation
  //   const requiredFields = {
  //     firstName: "First Name",
  //     lastName: "Last Name",
  //     email: "Email",
  //     phone: "Phone",
  //     address1: "Address",
  //     city: "City",
  //     stateId: "State",
  //     zip: "ZIP Code",
  //     corporateLicenseState: "Corporate License State",
  //     individualLicenseState: "Individual License State",
  //     individualLicenseNumber: "Individual License Number",
  //   };

  //   Object.entries(requiredFields).forEach(([field, label]) => {
  //     if (!data[field] || data[field].trim() === "") {
  //       errors[field] = `${label} is required`;
  //     }
  //   });

  //   // Email validation
  //   if (
  //     data.email &&
  //     !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(data.email)
  //   ) {
  //     errors.email = "Invalid email address";
  //   }

  //   // Phone validation
  //   if (data.phone && !/^\d{10}$/.test(data.phone.replace(/\D/g, ""))) {
  //     errors.phone = "Phone number must be 10 digits";
  //   }

  //   // ZIP code validation
  //   if (data.zip && !/^\d{5}(-\d{4})?$/.test(data.zip)) {
  //     errors.zip = "Invalid ZIP code";
  //   }

  //   // License number validation
  //   if (
  //     data.individualLicenseNumber &&
  //     !/^[A-Za-z0-9]{1,}$/.test(data.individualLicenseNumber)
  //   ) {
  //     errors.individualLicenseNumber = "Invalid license number";
  //   }

  //   return Object.keys(errors).length > 0 ? errors : null;
  // };
  const validateAddressFields = async (addressData) => {
    try {
      const payload = {
        address1: addressData.address1,
        city: addressData.city,
        state: addressData.stateId,
        zip: addressData.zip,
      };
      const data = await validateAddress(payload);
      if (data?.data?.errorMessage === "VALIDATION_STATE_ZIP_FAILURE") {
        return "Invalid combination of State and ZIP code";
      } else if (data?.status === "FAILURE") {
        return "Invalid address details";
      }
      return null;
    } catch (error) {
      console.log(error);
      return "Error validating address";
    }
  };

  // const handleContinue = async (e) => {
  //   e.preventDefault();
  //   let hasErrors = false;
  //   const newErrors = {};

  //   // Check for empty required fields
  //   buyerAgent.forEach((field) => {
  //     if (
  //       field.required &&
  //       (!agentData[field.name] || agentData[field.name].trim() === "")
  //     ) {
  //       newErrors[field.name] = `${field.label} is required`;
  //       hasErrors = true;
  //     }
  //   });

  //   // Email validation
  //   if (
  //     agentData.email &&
  //     !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(agentData.email)
  //   ) {
  //     newErrors.email = "Invalid email address";
  //     hasErrors = true;
  //   }

  //   // Phone validation
  //   if (
  //     agentData.phone &&
  //     !/^\d{10}$/.test(agentData.phone.replace(/\D/g, ""))
  //   ) {
  //     newErrors.phone = "Phone number must be 10 digits";
  //     hasErrors = true;
  //   }

  //   // ZIP validation
  //   if (agentData.zip && !/^\d{5}(-\d{4})?$/.test(agentData.zip)) {
  //     newErrors.zip = "Invalid ZIP code";
  //     hasErrors = true;
  //   }

  //   // Validate address if all required fields are filled
  //   if (!hasErrors) {
  //     const addressError = await validateAddressFields(agentData);
  //     if (addressError) {
  //       newErrors.address = addressError;
  //       hasErrors = true;
  //     }
  //   }

  //   setErrors(newErrors);

  //   if (!hasErrors) {
  //     console.log("Submitted Agent Data:", agentData);
  //     setSubmittedAccordions((prev) => [...prev, 3]);
  //     setCollapseAccordian(4);
  //   }
  // };

  // Update handleAgentChange function
  // const handleContinue = async (e) => {
  //   e.preventDefault();
  //   let hasErrors = false;
  //   const newErrors = {};

  //   // Custom validation messages mapping
  //   const errorMessages = {
  //     firstName: "Invalid Name",
  //     lastName: "Invalid Name",
  //     agencyName: "Invalid Agency Name",
  //     address1: "Invalid Address",
  //     stateId: "Please select a state",
  //     city: "Invalid City",
  //     zip: "Invalid Zip Code",
  //     email: "Invalid Email",
  //     phone: "Invalid Phone Number",
  //     licenseNumber: "Invalid Individual License Number",
  //     licenseExpiryDate: "Invalid License expiry date",
  //   };

  //   // Check for empty required fields with custom messages
  //   buyerAgent.forEach((field) => {
  //     if (
  //       field.required &&
  //       (!agentData[field.name] || agentData[field.name].trim() === "")
  //     ) {
  //       newErrors[field.name] =
  //         errorMessages[field.name] || `${field.label} is required`;
  //       hasErrors = true;
  //     }
  //   });

  //   // Email validation
  //   if (agentData.email) {
  //     if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(agentData.email)) {
  //       newErrors.email = "Invalid Email";
  //       hasErrors = true;
  //     }
  //   }

  //   // Phone validation
  //   if (agentData.phone) {
  //     if (!/^\d{10}$/.test(agentData.phone.replace(/\D/g, ""))) {
  //       newErrors.phone = "Invalid Phone Number";
  //       hasErrors = true;
  //     }
  //   }

  //   // ZIP validation
  //   if (agentData.zip) {
  //     if (!/^\d{5}(-\d{4})?$/.test(agentData.zip)) {
  //       newErrors.zip = "Invalid Zip Code";
  //       hasErrors = true;
  //     }
  //   }

  //   // License Number validation (if present in the form)
  //   if (agentData.licenseNumber && agentData.licenseNumber.trim() === "") {
  //     newErrors.licenseNumber = "Invalid Individual License Number";
  //     hasErrors = true;
  //   }

  //   // License Expiry Date validation (if present in the form)
  //   if (
  //     agentData.licenseExpiryDate &&
  //     agentData.licenseExpiryDate.trim() === ""
  //   ) {
  //     newErrors.licenseExpiryDate = "Invalid License expiry date";
  //     hasErrors = true;
  //   }

  //   // Validate address if all required fields are filled
  //   if (!hasErrors) {
  //     const addressError = await validateAddressFields(agentData);
  //     if (addressError) {
  //       // Map address validation errors to specific fields
  //       if (addressError.includes("address")) {
  //         newErrors.address1 = "Invalid Address";
  //       }
  //       if (addressError.includes("city")) {
  //         newErrors.city = "Invalid City";
  //       }
  //       if (addressError.includes("state")) {
  //         newErrors.stateId = "Please select a state";
  //       }
  //       if (addressError.includes("zip")) {
  //         newErrors.zip = "Invalid Zip Code";
  //       }
  //       hasErrors = true;
  //     }
  //   }

  //   setErrors(newErrors);

  //   if (!hasErrors) {
  //     console.log("Submitted Agent Data:", agentData);
  //     setSubmittedAccordions((prev) => [...prev, 3]);
  //     setCollapseAccordian(4);
  //   }
  // };
  // Add this date validation function
  const isValidDate = (dateString) => {
    // Check if the date string matches the format MM/DD/YYYY
    const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/;
    if (!regex.test(dateString)) return false;

    // Check if it's actually a valid date
    const [month, day, year] = dateString.split("/").map(Number);
    const date = new Date(year, month - 1, day);
    return (
      date.getMonth() === month - 1 &&
      date.getDate() === day &&
      date.getFullYear() === year
    );
  };
  const validateField = (value, type, fieldName) => {
    const getEmptyFieldError = (fieldName) => {
      switch (fieldName) {
        case "firstName":
        case "lastName":
          return "Invalid Name";
        case "companyName":
          return "Invalid corporation name";
        case "address1":
          return "Invalid individual address";
        case "city":
          return "Invalid City";
        case "stateId":
          return "Please select a state";
        case "phone":
          return "Invalid Phone Number";
        case "zip":
          return "Invalid Zip Code";
        case "email":
          return "Invalid Email";
        case "organizationName":
          return "Please enter valid Non profit Entity";
        case "governmentEntityName":
          return "Please enter valid governmental entity";
        case "nonProfitCorpName":
          return "Please enter valid non-profit corporation";
        case "landTrustName":
          return "Please enter valid community land trust";
        case "housingCoopName":
          return "Please enter valid Housing cooperative ";
        case "ownerOccupiedName":
          return "Please enter valid Owner occupied";
        case "californiaStateName":
          return "Please enter valid California state";
        case "caBillOwnerOccupiedName":
          return "CA Bill Owner occupied name is required";
        case "caBillNonProfitName":
          return "Please enter valid non-profit corporation";
        case "caBillLandTrustName":
          return "Please enter valid community land trust";
        case "caBillHousingCoopName":
          return "Please enter valid Housing cooperative ";
        case "caBillCaliforniaStateName":
          return "Please enter valid California state";
        default:
          return "";
      }
    };

    if (!value?.trim()) return getEmptyFieldError(fieldName);

    switch (fieldName) {
      case "firstName":
      case "lastName":
        return /^[A-Za-z0-9\s]{1,30}$/.test(value) ? null : "Invalid Name";
      // case "middleName":
      //   return value && !/^[A-Za-z\s]{0,30}$/.test(value)
      //     ? "Middle name should contain only letters (max 30 characters)"
      //     : null;
      case "companyName":
        return /^[A-Za-z\s.'-]{1,100}$/.test(value)
          ? null
          : "Invalid corporation name";
      // case "address1":
      //   return value.length < 1
      //     ? "Address should be at least 5 characters long"
      //     : null;
      case "address1":
        return /^[a-zA-Z0-9#(),.'\s]*$/.test(value) ? null : "Invalid Name";

      case "zip":
        return /^\d{5}(-\d{4})?$/.test(value) ? null : "Invalid Zip Code";
      case "phone":
        return /^\d{10}$/.test(value.replace(/\D/g, ""))
          ? null
          : "Invalid Phone Number";
      case "email":
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
          ? null
          : "Invalid Email";
      default:
        return null;
    }
  };

  const agentPhoneNumberVerification = async (name, value) => {
    try {
      const [phoneInUse, phoneVerified] = await Promise.all([
        isPhoneNoInUse(value),
        isPhoneNoVerified(value),
      ]);

      if (phoneInUse?.data?.data) {
        setIsAgentPhoneVerified(false);
        setAgentSendVerificationCode({
          message:
            "This phone number is already verified for another user. Please use a different number.",
          showCta: false,
        });
      } else if (phoneVerified?.data?.data) {
        setIsAgentPhoneVerified(true);
        setAgentSendVerificationCode({
          message: null,
          showCta: false,
        });
      } else {
        setIsAgentPhoneVerified(false);
        setAgentSendVerificationCode({
          message: "We will text you one time verification code",
          showCta: true,
        });
      }

      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  
 const handleAgentPhoneBlur = async (e) => {
    const { name, value } = e.target;
    let fieldError = {};
    // For phone, clean to digits only before validation/verification
    const cleanValue = name === "phone" ? value.replace(/\D/g, "") : value;
    if (name === "phone") {
      const phoneError = validateField(cleanValue, "phone", name);
      if (phoneError) {
        fieldError[name] = phoneError;
        setAgentSendVerificationCode({
          message: null,
          showCta: false,
        });
        setIsAgentPhoneVerified(false);
      } else {
        agentPhoneNumberVerification(name, cleanValue);
      }
    } else {
      const error = validateField(value, "text", name);
      if (error) {
        fieldError[name] = error;
      }
    }

    setErrors((prev) => ({
      ...prev,
      [name]: fieldError[name],
    }));
  };
  
  const handleClose = () => setShowVerifyModal(false);

  const handleAgentShow = (e) => {
    e.preventDefault();
    setShowVerifyModal(true); // assuming you're using the same modal
  };

  // Add this new function in your component
  const handleBlurValidation = (e) => {
    const { name, value } = e.target;
    const newErrors = { ...errors };

    // Skip validation for individualLicenseState field
    if (
      name === "individualLicenseState" ||
      name === "corporateLicenseNumber" ||
      name === "corporateLicenseState" ||
      name === "middleInitials"
    ) {
      return;
    }

    // Handle empty required fields first
    if (!value || value.trim() === "") {
      newErrors[name] = `${name === "licenseExpiryDate"
        ? "Invalid License expiry date"
        : name === "email"
          ? "Invalid Email"
          : name === "phone"
            ? "Invalid Phone Number"
            : name === "zip"
              ? "Invalid Zip Code"
              : name === "stateId"
                ? "Please select a state"
                : "Invalid " + name.replace(/([A-Z])/g, " $1").toLowerCase()
        }`;
      setErrors(newErrors);
      setGetLicenceErrorDesc("");
      return;
    }

    // Field-specific validation
    switch (name) {
      case "stateId":
        if (!states.includes(value)) {
          newErrors[name] = "Please select a state";
        } else {
          delete newErrors[name];
        }
        break;
      // case "middleName":
      //   if (!middleName.includes(value)) {
      //     newErrors[name] = "";
      //   }
      //   break;
      case "licenseExpiryDate":
        if (!isValidDate(value)) {
          newErrors[name] = "Please enter a valid date in MM/DD/YYYY format";
        } else {
          const currentDate = new Date();
          currentDate.setHours(0, 0, 0, 0);

          const [month, day, year] = value.split("/");
          const expiryDate = new Date(year, month - 1, day);
          expiryDate.setHours(0, 0, 0, 0);

          if (expiryDate < currentDate) {
            newErrors[name] = "Invalid License expiry date";
          } else {
            delete newErrors[name];
          }
        }
        break;

      case "email":
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
          newErrors[name] = "Invalid Email";
        } else {
          delete newErrors[name];
        }
        break;

      case "phone":
        if (!/^\d{10}$/.test(value.replace(/\D/g, ""))) {
          newErrors[name] = "Invalid Phone Number";
        } else {
          delete newErrors[name];
        }
        break;

      case "zip":
        if (!/^\d{5}(-\d{4})?$/.test(value)) {
          newErrors[name] = "Invalid Zip Code";
        } else {
          delete newErrors[name];
        }
        break;

      case "city":
        // Only validate if there are no suggestions showing
        if (!showSuggestions) {
          if (value.trim() === "") {
            newErrors[name] = "Invalid City";
          } else {
            delete newErrors[name];
          }
        }
        break;

      default:
        if (value.trim() === "") {
          newErrors[name] = `Invalid ${name
            .replace(/([A-Z])/g, " $1")
            .toLowerCase()}`;
        } else {
          delete newErrors[name];
        }
    }

    setErrors(newErrors);
  };

  const handleContinue = async (e) => {
    e.preventDefault();
    let hasErrors = false;
    const newErrors = {};
    //  Phone number must be verified before proceeding
    if (
      !isAgentPhoneVerified &&
      selectedDescription === "Agent" &&
      buyingForSelf === "No"
    ) {
      newErrors.phone = "Please verify your phone number";
      hasErrors = true;
    }

    const sameBuyerEmail = primaryBuyerData?.email?.toUpperCase() === agentData?.email?.toUpperCase();
    const sameCoBuyerEmail = cobuyerData?.email?.toUpperCase() === agentData?.email?.toUpperCase();


    if (primaryBuyerData?.email?.length > 0 && sameBuyerEmail) {
      hasErrors = true;
      newErrors["email"] = "Buyer and Agent email should not be same";

    }
    if (cobuyerData?.email?.length > 0 && sameCoBuyerEmail) {

      hasErrors = true;
      newErrors["email"] = "Co-Buyer and Agent email should not be same";

    }

    // Custom validation messages mapping
    const errorMessages = {
      firstName: "Invalid Name",
      lastName: "Invalid Name",
      agencyName: "Invalid Agency Name",
      address1: "Invalid Address",
      stateId: "Please select a state",
      city: "Invalid City",
      zip: "Invalid Zip Code",
      email: "Invalid Email",
      phone: "Invalid Phone Number",
      individualLicenseNumber: "Invalid Individual License Number",
      licenseExpiryDate: "Invalid License expiry date",
    };

    // Check for empty required fields with custom messages
    buyerAgent.forEach((field) => {
      if (field.name === "individualLicenseState") {
        return; // Skip this iteration
      }
      if (agentData["individualLicenseNumber"].trim() === "") {
        setGetLicenceErrorDesc("");
      }
      if (
        field.required &&
        (!agentData[field.name] || agentData[field.name].trim() === "")
      ) {
        newErrors[field.name] =
          errorMessages[field.name] || `${field.label} is required`;
        hasErrors = true;
      }
    });
    // In your handleContinue function, modify the license expiry date validation
    if (agentData.licenseExpiryDate) {
      if (!isValidDate(agentData.licenseExpiryDate)) {
        newErrors.licenseExpiryDate =
          "Please enter a valid date in MM/DD/YYYY format";
        hasErrors = true;
      } else {
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);

        const [month, day, year] = agentData.licenseExpiryDate.split("/");
        const expiryDate = new Date(year, month - 1, day);
        expiryDate.setHours(0, 0, 0, 0);

        if (expiryDate < currentDate) {
          newErrors.licenseExpiryDate = "Invalid License expiry date";
          hasErrors = true;
        }
      }
    }

    const nameRegex = /^[a-zA-Z0-9\-._' ]*$/;

    if (agentData.firstName && !nameRegex.test(agentData.firstName)) {
      newErrors.firstName = "Invalid Name";
      hasErrors = true;
    }

    if (agentData.lastName && !nameRegex.test(agentData.lastName)) {
      newErrors.lastName = "Invalid Name";
      hasErrors = true;
    }
    if (agentData.agencyName && !nameRegex.test(agentData.agencyName)) {
      newErrors.agencyName = "Invalid Agency Name";
      hasErrors = true;
    }
    // Address regex validation
    const addressRegex = /^[A-Za-z0-9\s.,#'-]+$/;

    if (agentData.address1 && !addressRegex.test(agentData.address1)) {
      newErrors.address1 = "Invalid Address";
      hasErrors = true;
    }
    // Email validation
    if (agentData.email) {
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(agentData.email)) {
        newErrors.email = "Invalid Email";
        hasErrors = true;
      }
    }

    // Phone validation
    if (agentData.phone) {
      if (!/^\d{10}$/.test(agentData.phone.replace(/\D/g, ""))) {
        newErrors.phone = "Invalid Phone Number";
        hasErrors = true;
      }
    }

    // ZIP validation
    if (agentData.zip) {
      if (!/^\d{5}(-\d{4})?$/.test(agentData.zip)) {
        newErrors.zip = "Invalid Zip Code";
        hasErrors = true;
      }
    }


    console.log('newErrors ->', Object.keys(newErrors));
    if (
      newErrors &&
      Object.keys(newErrors)?.length > 0
    ) {
      const errorField = Object.keys(newErrors)[0];
      console.log('errorField ->', errorField);

      agentFormRef.current[errorField]?.focus();
      agentFormRef.current[errorField]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }

    // Only proceed with API calls if initial validations pass
    if (!hasErrors) {
      try {
        // First, validate address
        setIsLoading(true);

        const addressError = await validateAddressFields(agentData);
        if (addressError) {
          hasErrors = true;
          if (addressError.includes("State and ZIP")) {
            newErrors.stateId = "Please select a state";
            newErrors.zip = "Invalid Zip Code for selected state";
          } else {
            newErrors.address1 = "Invalid Address";
            newErrors.city = "Invalid City";
            newErrors.stateId = "Please select a state";
            newErrors.zip = "Invalid Zip Code";
          }
          setErrors(newErrors);
          setIsLoading(false);
          return; // Stop further processing
        }

        // If address validation passes, proceed with license verification
        if (!hasErrors) {
          setIsLoading(true);

          try {
            const licensePayload = {
              licenceNumber: agentData.individualLicenseNumber,
              stateId: agentData.stateId,
              affiliatedCompany: agentData.agencyName,
              agentEmailId: agentData.email,
              agentFirstName: agentData.firstName,
              agentLastName: agentData.lastName,
              agentLicenseState: agentData["individualLicenseState"],
              licenceExpiryDate:
                agentData.licenseExpiryDate &&
                  isValidDate(agentData.licenseExpiryDate)
                  ? agentData.licenseExpiryDate
                  : null,
              tempParam: 90017167011,
            };

            const response = await cifVerifyLicenseDetails(licensePayload);
            const status = response?.data?.verificationStatus;
            const acceptedLicenseStatus = [
              "LICENSE_FORMAT_NOT_ACTIVE",
              "NO_INPUT_DATA",
              "UNKNOWN_STATE_ID",
              "NO_LICENSE_FORMAT_FOUND",
              "LICENSE_RESPONSE_NULL",
              "LICENSE_APPROVED",
              "NO_PATTERN_IN_FORMAT",
              "LICENSE_FORMAT_OK",
              "LICENSE_ALREADY_APPROVED",
            ];

            const licenseResponse = response?.data?.data || response?.data;

            if (acceptedLicenseStatus.includes(status)) {
              setSubmittedAccordions((prev) => [...prev, 3]);
              setCollapseAccordian(4);
            } else {

              if (status === "LICENSE_FORMAT_NOT_OK") {
                // Show the exact format description from the response
                newErrors.individualLicenseNumber = `Invalid license format`;
                setGetLicenceErrorDesc(licenseResponse.licenseFormatDescription);
              } else if (status === "INVALID_LICENSE") {
                newErrors.individualLicenseNumber = `Invalid license number`;
              }
              else if (status === "LICENCE_EXP_DT_INVALID" || status === "INVALID_LICENSE_EXPIRY_DATE") {
                newErrors.individualLicenseNumber = `Invalid License expiry date`;
              }
              else if (status === "APPLICATION_ERROR") {
                if (licenseResponse.jurisdictName?.includes("License Expiry Date")) {
                  newErrors.licenseExpiryDate =
                    "License expiry date is invalid or expired";
                } else {
                  newErrors.individualLicenseNumber =
                    licenseResponse.jurisdictName ||
                    "License verification failed";
                }
              }
              hasErrors = true;
            }

          } catch (error) {
            console.error("License verification failed:", error);
            newErrors.individualLicenseNumber =
              "Failed to verify license. Please try again.";
            hasErrors = true;
          }
        }
      } catch (error) {
        console.error("Validation failed:", error);
        newErrors.general =
          "An error occurred during validation. Please try again.";
        hasErrors = true;
      } finally {
        // Set loading to false after all operations complete
        setIsLoading(false);
      }
    }

    setErrors(newErrors);

    if (!hasErrors) {
      console.log("Submitted Agent Data:", agentData);
      setSubmittedAccordions((prev) => [...prev, 3]);
      setCollapseAccordian(4);
       window.scrollTo(0, 1200); //Need Fix
    }
  };

  const handleAgentChange = (e) => {
    const { name, value } = e.target;
    if (name === "licenseExpiryDate") {
      // Remove any non-digit or non-slash characters
      let cleaned = value.replace(/[^\d/]/g, "");

      // Add slashes automatically
      if (cleaned.length >= 2 && cleaned.charAt(2) !== "/") {
        cleaned = cleaned.slice(0, 2) + "/" + cleaned.slice(2);
      }
      if (cleaned.length >= 5 && cleaned.charAt(5) !== "/") {
        cleaned = cleaned.slice(0, 5) + "/" + cleaned.slice(5);
      }

      // Limit to MM/DD/YYYY format
      if (cleaned.length <= 10) {
        setAgentData((prev) => ({
          ...prev,
          [name]: cleaned,
        }));
      }
    } else {
      setAgentData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    // Clear error for the field being changed
    setErrors((prev) => ({
      ...prev,
      [name]: undefined,
    }));

    if (name === "city") {
      const filteredCities = allCities.filter((city) =>
        city.toLowerCase().includes(value.toLowerCase())
      );
      setCitySuggestions(filteredCities);
      setShowSuggestions(true);
    }
  };
  useEffect(() => {
    const phone = agentData.phone;
    if (
      selectedDescription === "Agent" &&
      buyingForSelf === "No" &&
      phone?.length === 10 &&
      !isAgentPhoneVerified
    ) {
      agentPhoneNumberVerification("phone", phone);
    }
  }, [selectedDescription, buyingForSelf, agentData.phone]);

  useEffect(() => {
    if (individualLicenceState?.address?.state) {
      setAgentData((prev) => ({
        ...prev,
        individualLicenseState: individualLicenceState?.address?.state,
      }));
    }
  }, [individualLicenceState]);

      const formatPhoneNumber = (value) => {
    if (!value) return "";
    const cleaned = value.replace(/\D/g, "").slice(0, 10); // Only digits, max 10
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]})-${match[2]}-${match[3]}`;
    }
    return cleaned;
  };

  return (
    <>
      <div>
        {" "}
        <div className="accordion-item buyer-agent-accordion">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${collapseAccordian === 3 ? "" : "collapsed"
                }`}
              type="button"
              onClick={(e) => e.preventDefault()}
              aria-expanded={collapseAccordian === 3}
            >
              <div className="d-flex align-items-center justify-content-between w-100">
                <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
                  {submittedAccordions?.includes(3) &&
                    collapseAccordian !== 3 ? (
                    <BsCheckCircleFill className="icon_bid me-2" size={30} />
                  ) : (
                    <BsCheckCircleFill className="text-dark me-2" size={30} />
                  )}
                  <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
                    <span className="bid_font_cif">Agent's Information</span>

                  </div>
                </div>

                {/* Edit button shown only if accordion has been submitted */}
                {submittedAccordions?.includes(3) &&
                  collapseAccordian !== 3 && (
                    <Button
                      variant="link"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setCollapseAccordian(3);
                      }}
                      className="text-primary bid_edit mt-2 mt-sm-0"
                    >
                      Edit
                    </Button>
                  )}
              </div>
            </button>
          </h2>
          {/* Summary section when accordion is closed */}

          {collapseAccordian !== 3 && submittedAccordions?.includes(3) && (
            <div className="buyer-agent-summary p-3 border-bottom">
              <div className="ms-4">
                <p className="mb-3">
                  <p
                    style={{
                      fontFamily: "graphikmedium",
                      fontSize: "20px",
                      color: "#383b42",
                    }}
                  >
                    Agent's Information
                  </p>
                  <h5>Buyer's Agent</h5>
                </p>
                <div className="d-flex flex-column flex-md-row  ">
                  <div
                    className="mb-3 mb-md-0 me-md-4"
                    style={{ marginRight: "2rem" }}
                  >
                    {" "}
                    <p className="mb-0" style={{ color: "#383b42" }}>
                      Name: {`${agentData.firstName} ${agentData.lastName}`}
                    </p>
                    <p className="mb-0 my-2" style={{ color: "#383b42" }}>
                      Email: {agentData.email}
                    </p>
                    <p className="mb-0 my-2" style={{ color: "#383b42" }}>
                      Agency Name: {agentData.agencyName}
                    </p>
                  </div>{" "}
                  <div className="ms-4 ">
                    {" "}
                    <p className="mb-0" style={{ color: "#383b42" }}>
                      Individual License Number:{" "}
                      {agentData.individualLicenseNumber}
                    </p>
                    <p className="mb-0 my-2" style={{ color: "#383b42" }}>
                      Individual License Expiration Date:{" "}
                      {agentData.licenseExpiryDate}
                    </p>
                    <p className="mb-0 my-2" style={{ color: "#383b42" }}>
                      Individual License State :
                      {agentData.individualLicenseState}
                    </p>
                  </div>
                  {
                    agentData.corporateLicenseNumber.length > 0 &&
                     <div className="ms-4 ">
                    {" "}
                    <p className="mb-0" style={{ color: "#383b42" }}>
                      Corporation License Number:{" "}
                      {agentData.corporateLicenseNumber}
                    </p>

                    <p className="mb-0 my-2" style={{ color: "#383b42" }}>
                      Corporation License State :
                      {agentData.corporateLicenseState}
                    </p>
                  </div>
                  }
                 
                </div>
              </div>
            </div>
          )}
          <div
            className={`accordion-collapse collapse ${collapseAccordian === 3 ? "show" : ""
              }`}
          >
            {isEnabled && (
              <div className="accordion-body">
                <form >
                  <div className="second_heading_info">
                    As this profile information will be used to bind legal
                    contract, please ensure to add information correctly.
                    Missing information and/ or inaccurate information can cause
                    the contract to be rejected.
                  </div>
                  <Row>
                    {buyerAgent.map((field, index) => (
                      <Form.Group
                        inputRef={(el) =>
                          console.log('field.name ', field.name)
                            (agentFormRef.current[field.name] =
                              el)
                        }
                        as={Col}
                        md={6}
                        className="mb-3"
                        key={`agent-${index}`}
                      >
                        <p>
                          {field.label}
                          {field.required && (
                            <span className="text-danger">*</span>
                          )}
                        </p>
                        <Col sm="9">
                          {field.type === "select" ? (
                            <>
                              <Form.Select
                                ref={(el) => (agentFormRef.current[field.name] = el)}

                                name={field.name}
                                value={
                                  // If the field is individualLicenseState, use the value from individualLicenceState
                                  field.name === "individualLicenseState"
                                    ? agentData["individualLicenseState"]
                                    : agentData[field.name] || ""
                                }
                                onChange={(e) => {
                                  handleAgentChange(e);

                                  // const { name, value } = e.target;
                                  // console.log('name -> ', name);
                                  // if ((name === "phone" && /^\d*$/.test(value) && value.length <= 10) ||
                                  //   (name === "zip" && /^\d*$/.test(value) && value.length <= 5) ||
                                  //   (name !== "phone" && name !== "zip")) {
                                  //   handleAgentChange(e);
                                  // }
                                }} onBlur={handleBlurValidation} // Add this line
                                isInvalid={!!errors[field.name]}
                                className="py-3"
                                disabled={
                                  field.name === "individualLicenseState"
                                }
                              >
                                <option value="">
                                  Select {field.placeholder}
                                </option>
                                {states.map((option) => (
                                  <option key={option} value={option}>
                                    {option}
                                  </option>
                                ))}
                              </Form.Select>
                              {errors[field.name] && (
                                <div className="text-danger mt-1 small">
                                  {errors[field.name]}
                                </div>
                              )}
                            </>
                          ) : (
                            <div className="phone-field-wrapper">
                              <div className="phone-input-container">
                                <Form.Control

                                  ref={(el) => (agentFormRef.current[field.name] = el)}

                                  type={field.type}
                                  // placeholder={field.placeholder}
                                  placeholder={
                                    field.name === "address1"
                                      ? "Address"
                                      : field.placeholder
                                  }
                                  name={field.name}
                                   value={
                                    field.name === "phone"
                                      ? formatPhoneNumber(
                                          agentData[field?.name] || ""
                                        )
                                      : agentData[field?.name] || ""
                                  }
                                  // value={agentData[field.name] || ""}
                                  // onChange={(e) => {
                                  //   if (field.name === "phone") {
                                  //     const value = e.target.value;
                                  //     if (/^\d*$/.test(value) && value.length <= 10) {
                                  //       handleAgentChange(e);
                                  //     }
                                  //   } if (field.name === "zip") {
                                  //     const value = e.target.value;
                                  //     if (/^\d*$/.test(value) && value.length <= 5) {
                                  //       handleAgentChange(e);
                                  //     }
                                  //   } else {
                                  //     handleAgentChange(e)
                                  //   }
                                  // }
                                  // }
                                  onChange={(e) => {
                                      handleAgentChange(e);

                                    // const { name, value } = e.target;
                                    // console.log('name -> ', name);
                                    // if ((name === "phone" && /^\d*$/.test(value) && value.length <= 10) ||
                                    //   (name === "zip" && /^\d*$/.test(value) && value.length <= 5) ||
                                    //   (name !== "phone" && name !== "zip")) {
                                    //   handleAgentChange(e);
                                    // }
                                  }}

                                  // onBlur={handleBlurValidation}
                                  onBlur={
                                    field.name === "phone" &&
                                      selectedDescription === "Agent" &&
                                      buyingForSelf === "No"
                                      ? handleAgentPhoneBlur
                                      : handleBlurValidation
                                  }
                                  isInvalid={!!errors[field.name]}
                                  maxLength={field.maxLength}
                                  className={`bg-bid-in ${field.name === "licenseExpiryDate"
                                    ? "license-expiry-date"
                                    : ""
                                    }`}
                                  disabled={
                                    field.name === "email" &&
                                    selectedDescription === "Agent" &&
                                    buyingForSelf === "No"
                                  }
                                />
                                {/* Phone verification icons */}
                                {field.name === "phone" &&
                                  selectedDescription === "Agent" &&
                                  buyingForSelf === "No" && (
                                    <div className="phone-status-icons">
                                      {agentData[field.name]?.length === 10 && (
                                        <>
                                          {isAgentPhoneVerified ? (
                                            <img
                                              src={VerificationTick}
                                              alt="verified"
                                              className="phone-verification-icon"
                                            />
                                          ) : (
                                            agentData[field.name]?.length ===
                                            10 && (
                                              <img
                                                src={VerificationPending}
                                                alt="verification pending"
                                                className="phone-verification-icon"
                                              />
                                            )
                                          )}
                                        </>
                                      )}
                                    </div>
                                  )}
                                {errors[field.name] && (
                                  <div className="text-danger mt-1 small">
                                    {errors[field.name]}
                                    {field.name === "individualLicenseNumber" &&
                                      getLicenceErrorDesc && (
                                        <OverlayTrigger
                                          placement="bottom"
                                          overlay={(props) => (
                                            <Tooltip
                                              {...props}
                                              className="document-upload-custom-tooltip"
                                            >
                                              {getLicenceErrorDesc}
                                            </Tooltip>
                                          )}
                                        >
                                          <span>
                                            <BsInfoCircle
                                              className="ms-2 "
                                              style={{
                                                cursor: "pointer",
                                                color: "#95A9BD",
                                                fontSize: "15px",
                                                background: "#EDF5FD",
                                                borderRadius: "50%",
                                              }}
                                            />
                                          </span>
                                        </OverlayTrigger>
                                      )}
                                  </div>
                                )}

                                {field.name === "city" &&
                                  showSuggestions &&
                                  citySuggestions.length > 0 && (
                                    <div className="suggestions-container-bid">
                                      {citySuggestions.map(
                                        (suggestion, index) => (
                                          <div
                                            key={index}
                                            className="suggestion-item"
                                            onClick={() =>
                                              handleSuggestionClick(suggestion)
                                            }
                                          >
                                            {suggestion}
                                          </div>
                                        )
                                      )}
                                    </div>
                                  )}

                                {/* Verification message below input */}
                                {field.name === "phone" &&
                                  agentData[field.name]?.length === 10 &&
                                  !isAgentPhoneVerified &&
                                  agentSendVerificationCode.message && (
                                    <div className="errorTxt">
                                      {agentSendVerificationCode.message}
                                    </div>
                                  )}
                              </div>
                              {/* Verify Button */}
                              {field.name === "phone" &&
                                agentData[field.name]?.length === 10 &&
                                !isAgentPhoneVerified &&
                                agentSendVerificationCode.showCta && (
                                  <button
                                    onClick={handleAgentShow}
                                    className="phone-verify-button"
                                  >
                                    Verify
                                  </button>
                                )}
                            </div>
                          )}
                        </Col>
                      </Form.Group>
                    ))}
                  </Row>
                  {errors.address && (
                    <div className="text-danger mb-3">{errors.address}</div>
                  )}

                  <Button type="submit"
                    variant="primary"
                    // disabled={isValidating}
                    onClick={handleContinue}
                    className="continueCTA">
                    {"Continue"}
                  </Button>


                </form>
                {isLoading && <ShimmerText line={5} gap={10} />}{" "}
                {/* Show shimmer when loading */}
              </div>
            )}
          </div>
        </div>
      </div>
      {showVerifyModal && (
        <VerifyPhoneModal
          handleClose={handleClose}
          show={showVerifyModal}
          phoneNumber={agentData.phone}
        />
      )}
    </>
  );
};

export default EditBuyersAgent;

